/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    object, string, arrayOf, shape,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { Grid, Button } from '@material-ui/core';
import ReactMarkdown from 'react-markdown';
import { getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import ClubPageStyle from './style/ClubPageStyle';
import SubCollection from '../../ContentTypeComponents/SubCollection/SubCollection';
import replaceSpecialChar from '../../../helpers/replaceSpecialChar';
import { trackEvent } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import BlockHeading from '../../ContentTypeComponents/BlockHeading';

const useStyles = makeStyles((theme) => ClubPageStyle(theme));

const ClubPage = ({
    logo, heading, text, moreText, headerbackground, clubTypeContent, Disclaimer, featureFlags, subcollectionBlock, titleFontFamily,
}) => {
    const seed = useUIDSeed();
    const classes = useStyles({ titleFontFamily });
    const [showMore, setShowMore] = useState(false);
    const [isClub, setClubAvail]  = useState([]);
    const dispatch = useDispatch();
    const handleToggle = () => {
        setShowMore(!showMore);
    };
    const buttondata = showMore ? '..less' : '...more';

    const setClubType = (type) => {
        setClubAvail([type]);
    };

    const tackEventClick = (clubgaTag, gaLabel) => {
        dispatch(trackEvent({
            eventCategory: clubgaTag?.gaConstants?.tracking_event_category || '',
            eventAction: clubgaTag?.gaConstants?.tracking_event_action || '',
            eventLabel: gaLabel?.club_product?.tracking_event_label || '',
        }));
    };
    const clubSectionCategory = (type) => (
        <>
            {type.product_blocks.map((clubData) => (
                <div key={seed(clubData.club_product)} className={classes.typeData}>
                    <div className={classes.imageMaincont}>
                        <div className={classes.code} />
                        <Link
                            to={clubData.club_product?.url}
                            onClick={() => tackEventClick(type, clubData)}
                        >
                            <img className={classes.typeImage} src={(clubData.club_product?.image?.url)} alt={clubData.club_product?.alternate_text || clubData.club_product?.label || 'Fruit Club Product'} />
                        </Link>
                    </div>
                    <div className={classes.content}>
                        {clubData?.club_product?.label && <span className={classes.labelStyle}>{ReactHtmlParser(replaceSpecialChar(clubData.club_product?.label, false))}</span>}
                        <p>{ReactHtmlParser(replaceSpecialChar(clubData.club_product?.description, false))}</p>
                        {clubData.club_product?.passport_eligible && featureFlags['is-prime-free-ship-icon-enabled'] && (
                            <img className={classes.passportEligibleImage} src="https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/blt1a8ac8abec129e11/5f3ba5ec48bdc47f3f1e899b/PassportEligible.png" alt="Passport Eligible Banner" />
                        )}
                        {clubData.club_product?.price && <p className={classes.priceText}>Starting at:  $<span>{clubData.club_product?.price}</span></p>}
                        <Link
                            className={classes.decorationNone}
                            to={clubData.club_product?.url}
                            onClick={() => tackEventClick(type, clubData)}
                        >
                            <Button color="secondary" variant="contained" className={classes.buyNowButton}>Buy Now</Button>
                        </Link>
                    </div>
                </div>
            ))}
        </>
    );
    return (
        <>
            {moreText ? (
                <div className={classes.main}>
                    <div style={{ backgroundImage: `url(${headerbackground?.url})` }} className={classes.headerImages}>
                        <img className={classes.lcpImage} src={headerbackground?.url} alt="header banner" />
                    </div>
                    <div className={classes.header} data-testid="desktop-club-header">
                        <div className={showMore ? classes.showMoreCopy : classes.showLessCopy}>
                            <img className={classes.headerLogo} src={logo?.url} alt="Harry and david logo" />
                            <p className={classes.headerHeading}>{heading}</p>
                            <p className={classes.headerText}>{text}</p>
                            <div className={classes.buttonBlock}>
                                {showMore ? <div className={classes.setAnimationMore}>{moreText}</div> : null}
                                <Button className={classes.moreLessButton} onClick={handleToggle}>{buttondata}</Button>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={classes.main}>
                    <div className={classes.textHeadingCenter}>
                        <ReactMarkdown source={heading} escapeHtml={false} />
                        <div className={classes.headerFullContent}>{ReactHtmlParser(text)}</div>
                    </div>
                    <img className={classes.headerSingleImage} src={headerbackground?.url} alt="fruit club banner" />
                </div>
            )}
            <Grid className={classes.clubTypes} data-testid="desktop-club-types">
                <div className={isClub.length > 0 ? classes.clubs : classes.clubsCategoryTitle} tabIndex={0} role="button" onKeyDown={() => { }} onClick={() => { setClubAvail([]); }}>Clubs: </div>
                {clubTypeContent.map((club) => (
                    <div className={classes.clubs} key={seed(club)} tabIndex={0} role="button" onKeyDown={() => { }} onClick={() => { setClubType(club); }}>  {club.title} |</div>
                ))}
            </Grid>
            {isClub.length > 0 ? isClub.map((type) => (
                <div key={seed(type)} className={classes.clubsType}>
                    <h3 className={classes.clubHeading}>{ReactHtmlParser(replaceSpecialChar(type.heading))}</h3>
                    <Grid className={classes.typeContainer}>
                        {clubSectionCategory(type)}
                    </Grid>
                </div>
            )) : clubTypeContent.map((type) => (
                <div key={seed(type)} className={classes.clubsType}>
                    <h4 className={classes.clubHeading}>{ReactHtmlParser(replaceSpecialChar(type.heading))}</h4>
                    <Grid className={classes.typeContainer}>
                        {clubSectionCategory(type)}
                    </Grid>
                </div>
            ))}
            {subcollectionBlock?.length > 0 && subcollectionBlock?.map((block) => (
                <>
                    {block?.heading && <BlockHeading data={block} />}
                    <SubCollection data={block} />
                </>
            ))}
            {Disclaimer?.map((info) => (
                <div key={seed(info)} className={classes.disclaimer}>
                    <p className={classes.disclaimerHeading}>{info.heading}</p>
                    <p className={classes.disclaimerContent}>{ReactHtmlParser(info.content)}</p>
                </div>
            ))}
        </>
    );
};

ClubPage.defaultProps = {
    titleFontFamily: '',

};
// TODO: Create Model
ClubPage.propTypes = {
    logo: object.isRequired,
    heading: string.isRequired,
    moreText: string.isRequired,
    text: string.isRequired,
    titleFontFamily: string,
    headerbackground: object.isRequired,
    clubTypeContent: arrayOf(shape({
        product_blocks: arrayOf(shape({
            image: string,
            alternate_text: string,
            label: string,
            description: string,
            price: string,
            url: string,
        })).isRequired,
    })).isRequired,
    Disclaimer: arrayOf(shape({
        heading: string,
        content: string,
    })).isRequired,
    featureFlags: object.isRequired,
    subcollectionBlock: arrayOf(shape({
        reference: arrayOf(shape({
            pim_code: string,
        })),
    })).isRequired,
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});

export default (connect(mapStateToProps)(ClubPage));
